import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getReviewProductDetails, updateReviewStatus } from "../../../api/reviewApi";
import ProductImage from "../../../components/common/ProductImage";
import { renderStars, reviewStatusMap } from "../../../helpers/reviewHelper";
import ReviewCard from "../../review/reviewCard";
import Loader from "../../../components/Loader";

export default function ProductReviewDetails() {
    const { baseId } = useParams();
    const [reviewProductDetails, setReviewProductDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState("success");

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await getReviewProductDetails(baseId);
                if (res.data?.success) {
                    setReviewProductDetails(res.data.data);
                }
            } catch (error) {
                console.error("Error fetching product details:", error);
                setMessage("Failed to fetch product details.");
                setMessageType("error");
            } finally {
                setLoading(false);
            }
        };

        if (baseId) fetchData();
    }, [baseId]);

    const product = reviewProductDetails?.product;

    const handleStatusUpdate = async (newStatus) => {
        if (!reviewProductDetails) return;

        try {
            setLoading(true);
            const res = await updateReviewStatus(reviewProductDetails.baseId, newStatus);

            if (res.data?.success) {
                setReviewProductDetails((prev) => ({
                    ...prev,
                    isApproved: newStatus,
                }));
                setMessage(res.data?.message || "Review status updated successfully");
                setMessageType("success");
            } else {
                setMessage(res.data?.message || "Failed to update review status");
                setMessageType("error");
            }
        } catch (err) {
            console.error("Failed to update review status:", err);
            setMessage("Something went wrong while updating status");
            setMessageType("error");
        } finally {
            setLoading(false);
        }

        setTimeout(() => setMessage(null), 5000);
    };

    return (
        <div className="admin-page-wrap product-review-page">
            {/* Top Bar */}
            <div className="admin-top-bar-wrap">
                <div className="admin-top-bar-left">
                    <Link className="admin-top-bar-back" to="/admin/reviews">
                        Back
                    </Link>
                </div>
            </div>

            {/* Page Content */}
            <div className="admin-page-content">
                <div className="admin-page-title-wrap">
                    <h1 className="admin-page-heading">Review Product Details</h1>
                </div>

                {message && (
                    <div
                        className={`alert ${messageType === "success" ? "alert-success" : "alert-danger"}`}
                        style={{ marginTop: 10, padding: 10, borderRadius: 5 }}
                    >
                        {message}
                    </div>
                )}

                {/* Status Buttons */}
                <div className="admin-bottom-bar">
                    <div className="admin-bottom-bar-right">
                        {Object.entries(reviewStatusMap).map(([key, label]) => (
                            <button
                                key={key}
                                className={`admin-button power ${key == 1 ? "btn-success" : key == 2 ? "btn-danger" : "btn-secondary"
                                    }`}
                                onClick={() => handleStatusUpdate(parseInt(key))}
                                style={{ marginRight: 10 }}
                                disabled={loading}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Product Section */}

                {loading ? (
                    <Loader />
                ) : (
                    <>
                        {reviewProductDetails && (
                            <div className="admin-table-wrap">
                                <div className="admin-table">
                                    {/* Product Image */}
                                    {product?.photo ? (
                                        <ProductImage
                                            photo={product.photo}
                                            photoAlt={product.photo.photoAlt ?? "Product image"}
                                        />
                                    ) : (
                                        <span className="errorImage">Image Coming Soon</span>
                                    )}

                                    {/* Product Details */}
                                    <div className="my-products--coll cart-detail cart-grid-col product-description-title">
                                        <div className="cart-grid-desc-wrap">
                                            <p className="cart-desc-title bold-metaPro">
                                                Average Rating : {renderStars(reviewProductDetails?.averageRating)}
                                            </p>
                                            <ReviewCard
                                                review={reviewProductDetails}
                                                manufacturerName={product?.details?.manufacturerName}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        )}
                    </>
                )}
            </div>
        </div>
    );
}
